import React, { useState, useRef, useEffect, useCallback, memo } from "react";
import styled from "styled-components";
import {  Textarea, ActionIcon, Avatar, Badge, Box, Button, Card, Divider, Group, Loader, Menu, Modal, MultiSelect, ScrollArea, SegmentedControl, Select, Stack, Tabs, Text, TextInput, Tooltip } from "@mantine/core";
import moment from "moment";
import editIcon from "../../stories/assets/edit.svg";
import shareIcon from "../../stories/assets/share.svg";
import useStartupStore from "../../stores/startupStore";
import Mixpanel from "../Lib/mixpanel";
import MobileCategoryDetailView from "./MobileCategoryDetailView";
import MobileTaskBoardView from "./MobileTaskBoardView";
import ProgramGantt from "../../stories/Gantt";
import FullFeaturedKanbanWithMantine from "../../stories/FullFeaturedKanban";
import {
  IconCalendarEvent,
  IconChevronDown,
  IconFileText,
  IconStack2,
  IconPencil,
  IconUsers,
  IconTemplate,
  IconCalendar,
  IconUsersGroup,
  IconCheck,
} from "@tabler/icons-react";
import { IconDotsVertical } from "@tabler/icons-react";
import { IconArrowLeft } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { InviteMembers } from "./InviteMember";
import { IconUserPlus } from "@tabler/icons-react";
import { IconMessage } from "@tabler/icons-react";
import { IconDoor } from "@tabler/icons-react";
import { IconCopyPlus } from "@tabler/icons-react";
import ChatComponent from "./StartupChat";
import { useDisclosure } from "@mantine/hooks";
import fetchApi from "../Lib/api";
import Notification from "../Lib/Notification";
import { IconSearch } from "@tabler/icons-react";
import { IconX } from "@tabler/icons-react";
import { IconChecklist } from "@tabler/icons-react";
import { DatePickerComponent, TimePickerComponent } from "@syncfusion/ej2-react-calendars";
import useUserStore from "../../stores/userStore";
import ContainerButton from "../../stories/ContainerButton";
import { handleFollowUnfollow } from "./StartupShow";
import ContactMessage from "./ContactMessage";

import EditCategoryDrawer from "../../stories/EditCategoryDrawer";

const MemoContactMessage = memo(ContactMessage);
const MenuButton = styled.button`
  background: var(--color-container-card-default);
  border: none;
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: var(--color-container-card-hover);
  }
`;

const MobileContainer = styled.div`
  padding: 16px;
  background-color: #f8f9fa;
  min-height: 100vh;
`;

const ProjectHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: white;
  border-radius: 16px;
  padding: 12px 12px 14px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
`;

const ProjectTitle = styled.h1`
  font-size: 15px;
  font-weight: 700;
  margin: 0 0 6px 0;
  color: #1a1a1a;
  line-height: 1.3;
  word-break: break-word;
`;

const ProjectMeta = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
`;

const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #666;

  svg {
    color: #999;
  }
`;

const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin: 16px 0 16px 0;
  color: #1a1a1a;
`;

const CategoryCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.2s ease;

  &:active {
    transform: scale(0.98);
  }
`;

const CategoryHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
`;

const CategoryIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: ${props => props.bgColor || '#f0f0f0'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    color: ${props => props.iconColor || '#666'};
  }
`;

const CategoryInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

const CategoryName = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: #1a1a1a;
`;

const CategoryDate = styled.div`
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const ProgressSection = styled.div`
  margin-top: 12px;
`;

const ProgressHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

const ProgressLabel = styled.span`
  font-size: 13px;
  color: #666;
`;

const ProgressPercentage = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  background: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
`;

const ProgressFill = styled.div`
  height: 100%;
  background: ${props => {
    if (props.percentage === 100) return '#63ba3c';
    if (props.percentage >= 50) return '#ea9713';
    return '#0251cc';
  }};
  width: ${props => props.percentage}%;
  transition: width 0.3s ease;
`;

const StatusBadges = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  margin-top: 8px;
`;

const NotionBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: #f8f9fa;
  border-radius: 6px;
  font-size: 11px;
  color: #666;

  img {
    width: 14px;
    height: 14px;
  }
`;

const StartupImage = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  object-fit: cover;
  flex-shrink: 0;
  cursor: pointer;
`;

const ProjectTitleDiv = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
`;

const CompactMembers = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
`;

const MembersLabel = styled.span`
  font-size: 12px;
  color: var(--color-background-main);
  opacity: 0.7;
  font-weight: 500;
`;

const MembersAvatars = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
`;

const MemberAvatar = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid var(--color-container-card-default);
  cursor: pointer;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: scale(1.1);
  }
`;

const MemberInitials = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #EDEDED;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  color: var(--color-background-main);
  border: 1px solid #EDEDED;
  cursor: pointer;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: scale(1.1);
  }
`;

const SeeMoreButton = styled.button`
  background: none;
  border: none;
  color: var(--color-button-accent);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  text-align: left;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
`;
const ActionButton = styled.button`
  background-color: var(--color-container-card-default);
  border: none;
  border-radius: 4px;
  min-width: fit-content;
  cursor: pointer;
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  img {
    width: 15px;
    height: 15px;
  }
`;

const ProjectEditIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const EditButton = styled.button`
margin-left: auto;
`
const RoadmapTitleContainer = styled.div`
display: flex;
justify-content: space-between;
`

const ProjectInfo = styled.div`
flex-grow: 1;
`


const MobileRoadmapView = () => {
  // Internal view state management
  const [currentView, setCurrentView] = useState("roadmap"); // "roadmap", "detail", "taskboard", "gantt", "kanban"
  const [previousView, setPreviousView] = useState("roadmap"); // Track previous view for back navigation
  const {
    startup,
    slug,
    members,
    role,
    program,
    selectedProgram,
    setProgram,
    setSelectedProgram,
    setCategory,
    isOwner,
    isMember,
    isSubmitted,
    isFollowing,
    submittedAt,
    setIsSubmitted,
    setSubmittedAt,
    entity
  } = useStartupStore((state) => ({
    startup: state.startup,
    slug: state.slug,
    members: state.members,
    role: state.role,
    program: state.program,
    selectedProgram: state.selectedProgram,
    setProgram: state.setProgram,
    setSelectedProgram: state.setSelectedProgram,
    setCategory: state.setCategory,
    isOwner: state.isOwner,
    isMember: state.isMember,
    isSubmitted: state.isSubmitted,
    isFollowing: state.isFollowing,
    submittedAt: state.submittedAt,
    setIsSubmitted: state.isSubmitted,
    setSubmittedAt: state.setSubmittedAt,
    entity: state.entity
  }));

  const { user: currentUser } = useUserStore((state) => ({
    user: state.user
  }));
  const [manageTeamOpened, { open: openManageTeam, close: closeManageTeam }] =
    useDisclosure(false);
  const [
    leaveProjectOpened,
    { open: openLeaveProject, close: closeLeaveProject },
  ] = useDisclosure(false);
  const [
    submitProjectOpened,
    { open: openSubmitProject, close: closeSubmitProject },
  ] = useDisclosure(false);
  const [projectSubmitLoading, setProjectSubmitLoading] = useState(false);
  const [submitValue, setSubmitValue] = useState("");
  const [submitData, setSubmitData] = useState([]);
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitProfessors, setSubmitProfessors] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [meetingDate, setMeetingDate] = useState(null);
  const [startDateTime, setStartDateTime] = useState(null);
  const [selectedSubmitUser, setSelectedSubmitUser] = useState(null);
  const [meetingOpened, { open: openMeeting, close: closeMeeting }] =
    useDisclosure(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [meetingNotification, setMeetingNotification] = useState(null);
  const [selectedNewOwner, setSelectedNewOwner] = useState("");
  const endTimeRef = useRef(null);
  const [users, setUsers] = useState({
    pending_requests: [],
    not_pending_requests: [],
  });
  const [loading, setLoading] = useState(false);
  const [teamSearch, setTeamSearch] = useState("");
  const [openChat, setOpenChat] = useState(false);
  const [notification, setNotification] = useState(null);
  const { t } = useTranslation();
  const [follow, setFollow] = useState(isFollowing);
  const [isCloning, setIsCloning] = useState(false);
  const [hasCopiedLink, setHasCopiedLink] = useState(false);
  const [tabValue, setTabValue] = useState("editor");
  const [isEditMode, setIsEditMode] = useState(false);
  const [drawerOpened, setDrawerOpened] = useState(false);
  // Category state
  const [isNewCategory, setIsNewCategory] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  // Fetch professors when submit modal opens

  useEffect(() => {
    if (!submitProjectOpened) return;

    const fetchProfessors = async () => {
      const response = await fetchApi(
        `/startup_entities/${slug}/join_requests/pending_requests_for_startup`,
        "GET"
      );
      if (response.ok) {
        const data = await response.json();
        const profs = data.not_pending_requests
          .filter((obj) => obj.user.role === 5)
          .map((obj) => obj.user);
        setSubmitProfessors(profs);
      }
    };
    fetchProfessors();
  }, [submitProjectOpened, slug]);

    // inside TableOfContentsFloating, below your useState declarations:

  

  const fetchTeamData = async () => {
    Mixpanel.custom("Manage Team Button Clicked", { startup_slug: slug });
    setLoading(true);
    try {
      const response = await fetchApi(
        `/startup_entities/${slug}/join_requests/pending_requests_for_startup`,
        "GET"
      );
      if (response.ok) {
        const res = await response.json();
        setUsers(res);
        openManageTeam();
      } else {
        const msg = (await response.json()).error;
        console.error(msg);
      }
    } catch (error) {
      console.error("Error fetching team data:", error);
    } finally {
      setLoading(false);
    }
  };

  const calculateCategoryProgress = (category) => {
    if (!category.sub_categories || category.sub_categories.length === 0) {
      return 0;
    }

    const totalSubcategories = category.sub_categories.length;
    const completedSubcategories = category.sub_categories.filter(
      (sub) => sub.status === "Close"
    ).length;

    return Math.round((completedSubcategories / totalSubcategories) * 100);
  };

  const getCategoryStatus = (category) => {
    let hasInProgress = false;
    let hasReview = false;
    let hasOpen = false;

    category.sub_categories?.forEach((subItem) => {
      if (subItem.status === "InProgress") hasInProgress = true;
      if (subItem.status === "Review") hasReview = true;
      if (subItem.status === "Open") hasOpen = true;
    });

    if (hasInProgress || hasReview) return "PR";
    if (hasOpen) return "TD";
    return "DN";
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "TD":
        return "#0251cc";
      case "PR":
        return "#ea9713";
      case "DN":
        return "#63ba3c";
      default:
        return "#999";
    }
  };

  const getIconForCategory = (index) => {
    const icons = [
      IconCalendarEvent,
      IconUsers,
      IconStack2,
      IconFileText,
      IconPencil,
    ];
    const Icon = icons[index % icons.length];
    return <Icon size={20} />;
  };

  const getIconColors = (status) => {
    switch (status) {
      case "DN":
        return { bgColor: "#e8f5e9", iconColor: "#63ba3c" };
      case "PR":
        return { bgColor: "#fff3e0", iconColor: "#ea9713" };
      case "TD":
        return { bgColor: "#e3f2fd", iconColor: "#0251cc" };
      default:
        return { bgColor: "#f0f0f0", iconColor: "#666" };
    }
  };

  const handleEditCategory = (category) => {
    setSelectedCategory(category);
    setIsNewCategory(false);
    setDrawerOpened(true);
  };

  const handleCategoryClick = (category, categoryIndex) => {
    if (isEditMode) {
      handleEditCategory(category);
      return;
    }
    setSelectedProgram({
      cid: categoryIndex,
      sid: 0,
      switch: true,
    });
    setPreviousView(currentView);
    setCurrentView("detail");
  };

  const handleBackToRoadmap = () => {
    setCurrentView("roadmap");
    setPreviousView("roadmap");
    setTabValue("editor"); // Reset segmented control to editor
  };

  const handleBackToPrevious = () => {
    setCurrentView(previousView);
  };

  const handleViewTaskboard = () => {
    setPreviousView(currentView); // Track that we're coming from detail
    setCurrentView("taskboard");
  };

  const handleViewGantt = () => {
    setPreviousView(currentView);
    setCurrentView("gantt");
  };

  const handleViewKanban = () => {
    setPreviousView(currentView);
    setCurrentView("kanban");
  };

  if (!program || !program.categories) {
    return (
      <>
        <ProjectHeader>
          <ProjectTitle>Loading...</ProjectTitle>
        </ProjectHeader>
      </>
    );
  }

  const resetSubmitFields = () => {
    setSubmitValue("");
    setSelectedSubmitUser(null);
    setSubmitData([]);
  };

  const resetMeetingForm = () => {
    setTitle("");
    setDescription("");
    setMeetingDate(null);
    setStartDateTime(null);
    setSelectedValues([]);
    if (endTimeRef.current) {
      endTimeRef.current.value = null;
      endTimeRef.current.min = null;
    }
  };
  const handleDateChange = (args) => {
    setMeetingDate(args.value);
    setStartDateTime(null);
    if (endTimeRef.current) {
      endTimeRef.current.value = null;
    }
  };

  const memberNames = members.map((mbr) => ({
    value: mbr.id,
    label: mbr.first_name + " " + mbr.last_name,
  }));

  const handleStartTimeChange = (args) => {
    if (args.value) {
      const selectedDate = new Date(meetingDate);
      selectedDate.setHours(args.value.getHours(), args.value.getMinutes(), 0);
      setStartDateTime(selectedDate);
      if (endTimeRef.current) {
        endTimeRef.current.value = null;
        endTimeRef.current.min = selectedDate;
      }
    }
  };

  // Submit Project Functions
  const handleProjectSubmit = async () => {
    setProjectSubmitLoading(true);
    try {
      const payload = {
        is_submitted: !isSubmitted,
      };
      const response = await fetchApi(
        `/startup_entities/${slug}/submit_project`,
        "POST",
        payload
      );
      if (response.ok) {
        const data = await response.json();
        setIsSubmitted(!isSubmitted);
        setSubmittedAt(data.submitted_at);
      } else {
        console.log("error in submitting project");
      }
    } catch (error) {
      console.log("error in submitting project", error);
    } finally {
      setProjectSubmitLoading(false);
    }
  };

  const handleSchedule = async () => {
    const startTime = performance.now();
    try {
      const response = await fetchApi("/meetings", "POST", {
        slug: slug,
        meeting: {
          title,
          description,
          start_time: startDateTime,
          end_time: endTimeRef.current.value,
          meeting_date: meetingDate,
        },
        attendees: selectedValues,
      });

      const responseTime = Math.round(performance.now() - startTime);

      if (response.ok) {
        const res = await response.json();
        setMeetingNotification({ type: "success", content: res.message });
        Mixpanel.content("Meeting", "Created", {
          creation_method: isMember || isOwner ? "Schedule" : "Request",
          meeting_title: title,
          attendees_count: selectedValues.length,
          response_time_ms: responseTime,
          startup_slug: slug,
        });
      } else {
        const msg = (await response.json()).error;
        setMeetingNotification({ type: "failure", content: msg });
        Mixpanel.error("Meeting Schedule/Request Error", {
          error_message: msg,
          error_type: "API Error",
          http_status: response.status,
          component: "Meeting Modal",
          user_action:
            isMember || isOwner ? "Schedule Meeting" : "Request Meeting",
          response_time_ms: responseTime,
          startup_slug: slug,
        });
      }
    } catch (error) {
      const responseTime = Math.round(performance.now() - startTime);
      console.error("Error during meeting creation:", error);
      Mixpanel.error("Meeting Schedule/Request Error", {
        error_message: error.message,
        error_type: "Network Error",
        component: "Meeting Modal",
        user_action:
          isMember || isOwner ? "Schedule Meeting" : "Request Meeting",
        response_time_ms: responseTime,
        startup_slug: slug,
      });
    } finally {
      resetMeetingForm();
    }
  };

  const handleSubmitChange = async (val) => {
    setSubmitValue(val);
    setSubmitData([]);

    if (!val.trim().length || val.trim().length < 3) {
      setSubmitLoading(false);
    } else {
      setSubmitLoading(true);
      try {
        const response = await fetch(`/api/users/search?search=${val}`);
        const users = await response.json();
        setSubmitData(users);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setSubmitLoading(false);
      }
    }
  };

  const handleSubmitConfirm = async () => {
    try {
      if (selectedSubmitUser) {
        await addProfessorToStartup(selectedSubmitUser);
      }
      await handleProjectSubmit();
    } catch (error) {
      console.log("error in submitting project ", error);
    } finally {
      closeSubmitProject();
      setSubmitValue("");
      setSelectedSubmitUser(null);
      setSubmitData([]);
    }
  };

  const addProfessorToStartup = async (user) => {
    try {
      const payload = {
        user_id: user.id,
        team_role: 5,
      };
      const response = await fetchApi(
        `/startup_entities/${slug}/add_professor`,
        "POST",
        payload
      );
      if (!response.ok) {
        console.log("error in adding professor");
      }
    } catch (error) {
      console.log("error in adding professor ", error);
    }
  };

  const handleClone = async () => {
    if (isCloning) return;
    setIsCloning(true);
    try {
      Mixpanel.button("Clone Project Button", {
        location: "Startup Header Action Buttons",
        startup_slug: slug,
      });

      const response = await fetchApi(
        `/startup_entities/${startup.slug}/clone`,
        "POST"
      );

      if (!response.ok) {
        throw new Error("Failed to clone project");
      }

      const data = await response.json();

      Mixpanel.content("Project Clone", "Created", {
        content_id: data.slug,
        source_startup_slug: startup.slug,
      });

      window.location.href = `/projects/${data.slug}`;
    } catch (error) {
      console.log(error);
      Mixpanel.error("Project Clone Error", {
        error_message: error.message,
        source_startup_slug: startup.slug,
      });
      alert("Failed to clone project. Please try again.");
    } finally {
      setIsCloning(false);
    }
  };

  const handleRole = async (membershipId, newRoleIndex, userToUpdate) => {
    const memberToUpdate = userToUpdate;
    const startTime = performance.now();
    try {
      const response = await fetchApi(
        `/startup_entities/${slug}/update_role`,
        "PUT",
        { membership_id: membershipId, new_role: newRoleIndex }
      );

      const responseTime = Math.round(performance.now() - startTime);
      if (response.ok) {
        const res = await response.json();
        setNotification({ type: "success", content: res.message });
        // Update local state so the UI reflects the new role immediately
        setUsers((prev) => ({
          ...prev,
          not_pending_requests: prev.not_pending_requests.map((item) => {
            const u = item.user;
            if (u.membership_id === membershipId) {
              return { ...item, user: { ...u, role: newRoleIndex } };
            }
            return item;
          }),
        }));
        Mixpanel.settings("Member Role", "Updated", {
          member_id: memberToUpdate ? memberToUpdate.id : "unknown",
          old_value: memberToUpdate ? memberToUpdate.role : "unknown",
          new_value: newRoleIndex,
          response_time_ms: responseTime,
          startup_slug: slug,
        });
      } else {
        const { error } = await response.json();
        setNotification({ type: "failure", content: error });
        Mixpanel.error("Member Role Update Error", {
          error_message: error,
          error_type: "API Error",
          http_status: response.status,
          component: "Manage Team Modal",
          user_action: "Update Member Role",
          member_id: memberToUpdate ? memberToUpdate.id : "unknown",
          response_time_ms: responseTime,
          startup_slug: slug,
        });
      }
    } catch (error) {
      const responseTime = Math.round(performance.now() - startTime);
      Mixpanel.error("Member Role Update Error", {
        error_message: error.message,
        error_type: "Network Error",
        component: "Manage Team Modal",
        user_action: "Update Member Role",
        member_id: userToUpdate ? userToUpdate.id : "unknown",
        response_time_ms: responseTime,
        startup_slug: slug,
      });
    }
  };



  const handleNewCategory = () => {
    // Reset the form fields for a new category
    setSelectedCategory(null);
    setIsNewCategory(true);
    setDrawerOpened(true);
  };

  return (
    <>
      <ProjectHeader>
        <StartupImage
          src={
            startup.image?.url ||
            "https://flowbite.com/docs/images/examples/image-3@2x.jpg"
          }
          alt="startup"
        />
        <ProjectInfo>
          <ProjectTitleDiv>
            <ProjectTitle>{startup?.name || "Project"}</ProjectTitle>
            <ProjectEditIcons>
              {(isOwner || role < 1) && !isSubmitted && (
                <Tooltip label="Edit project" withArrow color="#6c45e7">
                  <ActionButton aria-label="Edit project">
                    <a
                      href={`/projects/${slug}/edit`}
                      onClick={() =>
                        Mixpanel.button("Edit Project Button", {
                          location: "Startup Header",
                          startup_slug: slug,
                        })
                      }
                    >
                      <img src={editIcon} alt="Edit" />
                    </a>
                  </ActionButton>
                </Tooltip>
              )}
              <Tooltip
                label={hasCopiedLink ? "Link copied" : "Copy link"}
                withArrow
                color="#6c45e7"
              >
                <ActionButton
                  aria-label="Copy link"
                  onClick={() => {
                    navigator.clipboard.writeText(window.location.href);
                    Mixpanel.share("Project Link", "Clipboard", {
                      content_id: slug,
                      share_method: "copy_link",
                      startup_name: startup.name,
                      page_url: window.location.href,
                    });
                    setHasCopiedLink(true);
                    setTimeout(() => setHasCopiedLink(false), 1500);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img src={shareIcon} alt="Share" />
                </ActionButton>
              </Tooltip>

              <Menu shadow="md" width={220} withinPortal={true}>
                <Menu.Target>
                  <MenuButton>
                    <IconDotsVertical size={16} />
                  </MenuButton>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Label>Project</Menu.Label>
                    <Menu.Item
                      icon={<IconCopyPlus size={14} />}
                      onClick={handleClone}
                      disabled={isCloning}
                    >
                      {isCloning ? "Cloning..." : "Clone project"}
                    </Menu.Item>
                  <Menu.Divider />
                  <Menu.Label>Team & Communication</Menu.Label>
                  {!(isMember || isOwner) ? (
                    <>
                      <Menu.Item icon={<IconUserPlus size={14} />}>
                        <InviteMembers />
                      </Menu.Item>
                      <Menu.Item
                        icon={<IconCalendar size={14} />}
                        onClick={openMeeting}
                      >
                        {t("startups_page.members.request_meeting")}
                      </Menu.Item>
                    </>
                  ) : (
                    <>
                      <Menu.Item
                        icon={<IconMessage size={14} />}
                        onClick={() => {
                          setOpenChat(true);
                          Mixpanel.feature("Chat", "Opened", {
                            source: "Compact Header Menu",
                          });
                        }}
                      >
                        {t("startups_page.members.open_chat")}
                      </Menu.Item>
                      <Menu.Item
                        icon={<IconUsersGroup size={14} />}
                        onClick={fetchTeamData}
                      >
                        {t("startups_page.members.manage_team")}
                      </Menu.Item>
                      <Menu.Item
                        icon={<IconDoor size={14} />}
                        onClick={openLeaveProject}
                      >
                        Leave Project
                      </Menu.Item>
                      <Menu.Item
                        icon={<IconCalendar size={14} />}
                        onClick={openMeeting}
                      >
                        {t("startups_page.members.schedule")}
                      </Menu.Item>
                      {(isOwner || isMember) && (
                        <Menu.Item
                          icon={<IconCheck size={14} />}
                          onClick={openSubmitProject}
                          disabled={isSubmitted}
                        >
                          {isSubmitted ? "Submitted" : "Submit Project"}
                        </Menu.Item>
                      )}
                    </>
                  )}
                </Menu.Dropdown>
              </Menu>
            </ProjectEditIcons>
          </ProjectTitleDiv>
          <ProjectMeta>
            {startup.description &&
            startup.description.length > 40 &&
            !isDescriptionExpanded
              ? `${startup.description.substring(0, 40)}...`
              : startup.description}

            {startup.description && startup.description.length > 40 && (
              <SeeMoreButton
                onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
              >
                {isDescriptionExpanded ? "See less" : "See more"}
              </SeeMoreButton>
            )}
          </ProjectMeta>
          <CompactMembers>
            <ContainerButton
              buttonText={
                follow
                  ? t("startups_page.following")
                  : t("startups_page.follow")
              }
              action={async () => {
                const newFollowState = await handleFollowUnfollow(follow, slug);
                setFollow(newFollowState);
                Mixpanel.button(
                  newFollowState ? "Follow Button" : "Unfollow Button",
                  {
                    category: "Startup Engagement",
                    action: newFollowState ? "followed" : "unfollowed",
                    startup_slug: slug,
                    startup_name: startup.name,
                    initial_state: !newFollowState
                      ? "following"
                      : "not_following",
                  }
                );
              }}
            />
            {/* <MemoContactMessage
              slug={slug}
              isMember={isOwner || isMember}
              role={role}
            /> */}
            {members.slice(0, 8).map((member, index) => {
              const initials = `${
                member.first_name ? member.first_name[0] : ""
              }${member.last_name ? member.last_name[0] : ""}`;
              return (
                <a key={member.id} href={`/profile/user/${member.id}`}>
                  {member.avatar_url ? (
                    <MemberAvatar
                      src={member.avatar_url}
                      alt={`Member ${index + 1}`}
                    />
                  ) : (
                    <MemberInitials>{initials}</MemberInitials>
                  )}
                </a>
              );
            })}
            {(isMember || isOwner) && members.length < 15 && <InviteMembers />}
          </CompactMembers>
          {isSubmitted && (
            <p>
              <b>Submitted at:</b>{" "}
              {moment(submittedAt).format("MMM D, YYYY h:mm A")}
            </p>
          )}
        </ProjectInfo>
      </ProjectHeader>
      {(isOwner || isMember) && currentView === "roadmap" && (
        <SegmentedControl
          value={tabValue}
          onChange={(newValue) => {
            if (newValue === "gantt") {
              handleViewGantt();
            } else if (newValue === "kanban") {
              handleViewKanban();
            }
          }}
          size="sm"
          data={[
            { label: t("startups_page.editor_title"), value: "editor" },
            { label: t("startups_page.gantt"), value: "gantt" },
            { label: t("startups_page.kanban"), value: "kanban" },
          ]}
        />
      )}

      {/* Conditionally render content based on currentView */}
      {currentView === "roadmap" && (
        <>
          <RoadmapTitleContainer>
            <SectionTitle>Project Roadmap</SectionTitle>
            <EditButton>
              {(isOwner || isMember) && !isSubmitted && (
                <ActionIcon
                  onClick={() => setIsEditMode(!isEditMode)}
                  style={{ marginLeft: "auto" }}
                  variant="subtle"
                >
                  {isEditMode ? <IconX size={16} /> : <IconPencil size={16} />}
                </ActionIcon>
              )}
            </EditButton>
          </RoadmapTitleContainer>

          {program.categories.map((category, index) => {
        const progress = calculateCategoryProgress(category);
        const status = getCategoryStatus(category);
        const { bgColor, iconColor } = getIconColors(status);

        return (
          <CategoryCard
            key={category.id}
            onClick={() => handleCategoryClick(category, index)}
          >
            <CategoryHeader>
              <CategoryIcon bgColor={bgColor} iconColor={iconColor}>
                <IconTemplate size={20} />
              </CategoryIcon>
              <CategoryInfo>
                <CategoryName>{category.name}</CategoryName>
                {category.end_date && (
                  <CategoryDate>
                    {moment(category.end_date).format("MMM Do, YYYY")}
                  </CategoryDate>
                )}
              </CategoryInfo>
              {isEditMode && (
                <EditButton onClick={() => {}}>
                  <IconPencil size={12} />
                </EditButton>
              )}
            </CategoryHeader>

            <ProgressSection>
              <ProgressHeader>
                {/* <ProgressLabel>
                  {category.sub_categories?.length || 0} tasks
                </ProgressLabel> */}
                <ProgressPercentage>{progress}%</ProgressPercentage>
              </ProgressHeader>
              <ProgressBar>
                <ProgressFill percentage={progress} />
              </ProgressBar>
            </ProgressSection>

            <StatusBadges>
              <Badge
                variant="filled"
                style={{
                  backgroundColor: getStatusColor(status),
                  color: "white",
                }}
                size="sm"
              >
                {status}
              </Badge>
              {category.notion_page_id && (
                <NotionBadge>
                  <img src="/notion_logo.svg" alt="Notion" />
                  <span>Synced</span>
                </NotionBadge>
              )}
            </StatusBadges>
          </CategoryCard>
        );
      })}

          {/* Add New Category Button when in edit mode */}
          {isEditMode && (
            <Button onClick={handleNewCategory} fullWidth variant="outline">
              Add New Category
            </Button>
          )}
        </>
      )}

      {currentView === "detail" && (
        <MobileCategoryDetailView
          onBack={handleBackToRoadmap}
          onViewTaskBoard={handleViewTaskboard}
        />
      )}

      {currentView === "taskboard" && (
        <MobileTaskBoardView
          subCategoryId={program.categories?.[selectedProgram?.cid]?.sub_categories?.[selectedProgram?.sid]?.id || 0}
          subcategoryName={program.categories?.[selectedProgram?.cid]?.sub_categories?.[selectedProgram?.sid]?.name || "Task Board"}
          onBack={handleBackToPrevious}
        />
      )}

      {currentView === "gantt" && (
        <ProgramGantt onBack={handleBackToRoadmap} />
      )}

      {currentView === "kanban" && (
        <FullFeaturedKanbanWithMantine onBack={handleBackToRoadmap} />
      )}

      {(isMember || isOwner) && openChat && (
        <ChatComponent startupId={slug} setOpenChat={setOpenChat} />
      )}
      {/* Manage Team Modal */}
      <Modal
        opened={manageTeamOpened}
        onClose={closeManageTeam}
        size="xl"
        withCloseButton={false}
      >
        {notification && <Notification {...notification} />}
        <TextInput
          placeholder="Search by name or email"
          icon={<IconSearch size={16} />}
          value={teamSearch}
          onChange={(e) => setTeamSearch(e.currentTarget.value)}
          mb={12}
        />
        <Tabs defaultValue="pending" color="violet" keepMounted={false}>
          <Tabs.List>
            <Tabs.Tab value="pending">
              {t("startups_page.manage_team.pending")}
            </Tabs.Tab>
            <Tabs.Tab value="members">
              {t("startups_page.manage_team.all")}
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="pending" pt="xs">
            <Card radius="md">
              <div className="flow-root">
                <ul
                  role="list"
                  className="divide-y divide-gray-200 dark:divide-gray-700 list-none"
                >
                  {users.pending_requests
                    ?.filter(({ user }) => {
                      const q = teamSearch.toLowerCase();
                      if (!q) return true;
                      return (
                        `${user.first_name} ${user.last_name}`
                          .toLowerCase()
                          .includes(q) ||
                        (user.email || "").toLowerCase().includes(q)
                      );
                    })
                    .map(({ user }, i) => (
                      <li className="py-3 sm:py-4" key={user.email}>
                        <div className="flex items-center space-x-4">
                          <div className="flex-shrink-0">
                            {user.avatar_url ? (
                              <Avatar
                                src={user.avatar_url}
                                mx="auto"
                                className="w-8 h-8 rounded-full"
                              />
                            ) : (
                              <Avatar
                                mx="auto"
                                className="w-8 h-8 rounded-full"
                              >{`${user.first_name[0]}${user.last_name[0]}`}</Avatar>
                            )}
                          </div>
                          <div className="flex-1 min-w-0">
                            <a href={`/profile/${user.id}`}>
                              <p className="text-sm font-medium text-gray-900 truncate dark:text-white">{`${user.first_name} ${user.last_name}`}</p>
                              <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                                {user.email}
                              </p>
                            </a>
                          </div>
                          <div className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                            <Group gap={0} justify="flex-end">
                              <ActionIcon
                                variant="default"
                                size="xl"
                                onClick={() => handleRequest(true, i)}
                              >
                                <IconCheck size={22} stroke={1.5} />
                              </ActionIcon>
                              <ActionIcon
                                variant="default"
                                size="xl"
                                onClick={() => handleRequest(false, i)}
                              >
                                <IconX size={22} stroke={1.5} color="red" />
                              </ActionIcon>
                            </Group>
                          </div>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </Card>
          </Tabs.Panel>

          <Tabs.Panel value="members" pt="xs">
            <Card radius="md">
              <div className="flow-root">
                <ul
                  role="list"
                  className="divide-y divide-gray-200 dark:divide-gray-700 list-none"
                >
                  {users.not_pending_requests
                    ?.filter(({ user }) => {
                      const q = teamSearch.toLowerCase();
                      if (!q) return true;
                      return (
                        `${user.first_name} ${user.last_name}`
                          .toLowerCase()
                          .includes(q) ||
                        (user.email || "").toLowerCase().includes(q)
                      );
                    })
                    .map(({ user }, i) => (
                      <li className="py-3 sm:py-4" key={user.email}>
                        <div className="flex items-center space-x-4">
                          <div className="flex-shrink-0">
                            {user.avatar_url ? (
                              <Avatar
                                src={user.avatar_url}
                                mx="auto"
                                className="w-8 h-8 rounded-full"
                              />
                            ) : (
                              <Avatar
                                mx="auto"
                                className="w-8 h-8 rounded-full"
                              >{`${user.first_name[0]}${user.last_name[0]}`}</Avatar>
                            )}
                          </div>
                          <div className="flex-1 min-w-0">
                            <a href={`/profile/user/${user.id}`}>
                              <p className="text-sm font-medium text-gray-900 truncate dark:text-white">{`${user.first_name} ${user.last_name}`}</p>
                              <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                                {user.email}
                              </p>
                            </a>
                          </div>
                          <div className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                            <Group gap={8} justify="flex-end">
                              <Select
                                placeholder="Role"
                                size="xs"
                                value={String(user.role)}
                                onChange={(val) =>
                                  handleRole(
                                    user.membership_id,
                                    Number(val),
                                    user
                                  )
                                }
                                data={[
                                  { value: "0", label: "Founding Team" },
                                  { value: "1", label: "Member" },
                                  { value: "2", label: "Intern/Volunteer" },
                                  { value: "3", label: "Consultant" },
                                  { value: "4", label: "Investor" },
                                  { value: "5", label: "Professor" },
                                ]}
                                withinPortal
                              />
                            </Group>
                          </div>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </Card>
          </Tabs.Panel>
        </Tabs>
      </Modal>

      {/* Submit Project Modal */}
      <Modal
        opened={submitProjectOpened}
        onClose={() => {
          closeSubmitProject();
          resetSubmitFields();
        }}
        title={
          <Stack spacing={2}>
            <Group spacing={6}>
              <IconChecklist size={18} />
              <Text fw={700} size="lg">
                Submit Project
              </Text>
            </Group>
            <Text size="sm" color="dimmed">
              Review your team, add missing professors, and confirm submission.
            </Text>
          </Stack>
        }
        size="lg"
        radius="md"
        overlayProps={{ blur: 3 }}
      >
        <Stack spacing="md">
          <Group spacing="xs">
            <Badge color="violet" size="md">
              Professors
            </Badge>
            <Badge variant="outline" size="md">
              {submitProfessors.length} selected
            </Badge>
          </Group>

          <Tabs defaultValue="team" color="violet" keepMounted={false}>
            <Tabs.List>
              <Tabs.Tab value="team">Team</Tabs.Tab>
              <Tabs.Tab value="add">Add Professor</Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="team" pt="xs">
              <Card withBorder shadow="xs" radius="md" padding="md">
                <ScrollArea style={{ maxHeight: 320 }} type="auto">
                  {submitProfessors.length > 0 ? (
                    <Stack spacing="xs">
                      {submitProfessors.map((prof) => (
                        <Group
                          key={prof.id}
                          spacing="sm"
                          style={{
                            padding: 6,
                            border: "1px solid #F0F1F3",
                            borderRadius: 6,
                          }}
                        >
                          <Avatar src={prof.avatar_url} size="sm" radius="xl">
                            {!prof.avatar_url &&
                              `${prof.first_name?.[0] || ""}${
                                prof.last_name?.[0] || ""
                              }`}
                          </Avatar>
                          <div>
                            <Text size="md" fw={500}>
                              {prof.first_name} {prof.last_name}
                            </Text>
                            <Text size="sm" color="dimmed">
                              {prof.email}
                            </Text>
                          </div>
                        </Group>
                      ))}
                    </Stack>
                  ) : (
                    <Box
                      p="lg"
                      style={{
                        border: "1px dashed #E3E6EA",
                        borderRadius: 8,
                        textAlign: "center",
                      }}
                    >
                      <Text size="md" color="dimmed">
                        No professors added yet. Switch to "Add Professor" to
                        invite.
                      </Text>
                    </Box>
                  )}
                </ScrollArea>
              </Card>
            </Tabs.Panel>

            <Tabs.Panel value="add" pt="xs">
              <Card withBorder shadow="xs" radius="md" padding="md">
                {!selectedSubmitUser ? (
                  <TextInput
                    icon={<IconSearch size={16} />}
                    variant="default"
                    placeholder="Search by name or email"
                    value={submitValue}
                    onChange={(event) =>
                      handleSubmitChange(event.currentTarget.value)
                    }
                    rightSection={submitLoading ? <Loader size="1rem" /> : null}
                  />
                ) : (
                  <Box
                    style={{
                      position: "relative",
                      border: "1px solid #EEF1F4",
                      borderRadius: 8,
                      padding: 10,
                      background: "#FAFBFC",
                      minHeight: 48,
                    }}
                  >
                    <Button
                      variant="subtle"
                      size="xs"
                      style={{ position: "absolute", top: 6, right: 6 }}
                      onClick={() => setSelectedSubmitUser(null)}
                    >
                      <IconX size={14} />
                    </Button>
                    <Group>
                      <Avatar
                        src={selectedSubmitUser.avatar_url}
                        radius="xl"
                        size="sm"
                      >
                        {!selectedSubmitUser.avatar_url &&
                          `${selectedSubmitUser.first_name?.[0] || ""}${
                            selectedSubmitUser.last_name?.[0] || ""
                          }`}
                      </Avatar>
                      <div>
                        <Text size="md" fw={600}>
                          {selectedSubmitUser.first_name}{" "}
                          {selectedSubmitUser.last_name}
                        </Text>
                        <Text color="dimmed" size="sm">
                          {selectedSubmitUser.email}
                        </Text>
                      </div>
                    </Group>
                  </Box>
                )}

                {!selectedSubmitUser &&
                submitValue.trim().length > 0 &&
                !submitLoading ? (
                  submitData.length > 0 ? (
                    <ScrollArea
                      style={{ maxHeight: 260, marginTop: 8 }}
                      type="auto"
                    >
                      <Stack spacing={6}>
                        {submitData.map((user) => (
                          <Group
                            key={user.id}
                            spacing="sm"
                            style={{
                              padding: 8,
                              border: "1px solid #F0F1F3",
                              borderRadius: 6,
                              cursor: "pointer",
                              transition: "background 150ms",
                            }}
                            onClick={() => setSelectedSubmitUser(user)}
                          >
                            <Avatar src={user.avatar_url} radius="xl" size="sm">
                              {!user.avatar_url &&
                                `${user.first_name?.[0] || ""}${
                                  user.last_name?.[0] || ""
                                }`}
                            </Avatar>
                            <div>
                              <Text size="md" fw={500}>
                                {user.first_name} {user.last_name}
                              </Text>
                              <Text color="dimmed" size="sm">
                                {user.email}
                              </Text>
                            </div>
                          </Group>
                        ))}
                      </Stack>
                    </ScrollArea>
                  ) : (
                    <Box
                      p="sm"
                      mt={8}
                      style={{
                        border: "1px solid #eee",
                        borderRadius: 6,
                        textAlign: "center",
                      }}
                    >
                      <Text size="md">No results for "{submitValue}"</Text>
                    </Box>
                  )
                ) : null}
              </Card>
            </Tabs.Panel>
          </Tabs>

          <Divider my="xs" />

          <Group justify="space-between" align="center">
            <Text size="sm" color="dimmed">
              Submission is final and cannot be undone.
            </Text>
            <Group>
              <Button
                variant="subtle"
                color="red"
                onClick={() => closeSubmitProject()}
              >
                Cancel
              </Button>
              <Tooltip
                label="You need to have at least one professor before submitting the project"
                color="violet"
                disabled={
                  !(submitProfessors.length === 0 && !selectedSubmitUser)
                }
                withArrow
                position="bottom"
              >
                <div>
                  <Button
                    color="violet"
                    onClick={handleSubmitConfirm}
                    disabled={
                      isSubmitted ||
                      (submitProfessors.length === 0 && !selectedSubmitUser)
                    }
                    loading={projectSubmitLoading}
                  >
                    Confirm & Submit
                  </Button>
                </div>
              </Tooltip>
            </Group>
          </Group>
        </Stack>
      </Modal>

      {/* Meeting Modal */}
      <Modal
        opened={meetingOpened}
        onClose={closeMeeting}
        size="lg"
        radius="md"
        transitionProps={{ transition: "fade", duration: 200 }}
        withCloseButton={true}
      >
        <Stack spacing={18} className="p-5">
          {meetingNotification && <Notification {...meetingNotification} />}
          <Text size="lg" fw={500}>
            {t("startups_page.meeting.header")}
          </Text>
          <Text size="md">{t("startups_page.meeting.desc")}</Text>
          <TextInput
            size="md"
            label={t("startups_page.meeting.title")}
            value={title}
            onChange={(e) => setTitle(e.currentTarget.value)}
          />
          <Group grow>
            <label>Meeting Date:</label>
            <DatePickerComponent
              placeholder="Select Meeting Date"
              onChange={handleDateChange}
              min={new Date()}
            />
          </Group>

          <Group grow>
            <label>Start Time:</label>
            <TimePickerComponent
              placeholder="Select Start Time"
              enabled={!!meetingDate}
              onChange={handleStartTimeChange}
            />
          </Group>
          <Group grow>
            <label>End Time:</label>
            <TimePickerComponent
              ref={endTimeRef}
              placeholder="Select End Time"
              min={startDateTime}
              enabled={!!startDateTime}
            />
          </Group>
          <div onClick={(e) => e.stopPropagation()}>
            <MultiSelect
              data={memberNames}
              label="Select Members"
              placeholder="Choose people to invite"
              value={selectedValues}
              onChange={(values) => {
                setSelectedValues(values);
              }}
              withinPortal
            />
          </div>

          <Textarea
            size="md"
            radius="md"
            label={t("startups_page.meeting.agenda")}
            placeholder={t("startups_page.meeting.agenda_p")}
            onChange={(e) => setDescription(e.currentTarget.value)}
          />

          <Button
            onClick={handleSchedule}
            variant="default"
            fullWidth
            className="w-full px-12"
            disabled={!(title && description && startDateTime)}
          >
            {isMember || isOwner
              ? t("startups_page.meeting.buttonText_m")
              : t("startups_page.members.request_meeting")}
          </Button>
        </Stack>
      </Modal>

      {/* Leave Project Modal */}
      <Modal
        opened={leaveProjectOpened}
        onClose={closeLeaveProject}
        size="lg"
        radius="md"
        overlayProps={{ blur: 3 }}
        withCloseButton
        title={
          <Group spacing={6}>
            <IconDoor size={18} />
            <Text fw={700} size="lg">
              Leave Project
            </Text>
          </Group>
        }
      >
        <Stack spacing="md">
          {notification && <Notification {...notification} />}

          <Card
            withBorder
            shadow="xs"
            radius="md"
            padding="md"
            style={{ background: "#FFF5F5", borderColor: "#FFE3E3" }}
          >
            <Text size="sm" color="red">
              Leaving this project will remove your access. This action cannot
              be undone.
            </Text>
          </Card>

          {isOwner ? (
            <Stack spacing={8}>
              <Text fw={600} size="md">
                You are the owner
              </Text>
              <Text size="sm" color="dimmed">
                Select a new owner to transfer ownership before leaving.
              </Text>
              <Select
                placeholder="Select member"
                data={members
                  .filter((member) => member.id !== currentUser.id)
                  .map((member) => ({
                    value: String(member.id),
                    label: `${member.first_name} ${member.last_name} (${member.email})`,
                  }))}
                value={selectedNewOwner}
                onChange={setSelectedNewOwner}
              />
            </Stack>
          ) : (
            <Text size="md">
              You are about to leave this {entity.toLowerCase()}. You will lose
              all member access.
            </Text>
          )}

          <Divider my="xs" />

          <Group justify="space-between" align="center">
            <Text size="sm" color="dimmed">
              This will immediately revoke your permissions.
            </Text>
            <Group>
              <Button variant="subtle" onClick={closeLeaveProject}>
                Cancel
              </Button>
              <Button
                color="red"
                variant="filled"
                onClick={async () => {
                  try {
                    // Clear previous notifications
                    setNotification(null);

                    // Owners must select a new owner before leaving
                    const body = isOwner
                      ? { new_owner_id: Number(selectedNewOwner) }
                      : {};

                    const response = await fetchApi(
                      `/startup_entities/${slug}/remove_member`,
                      "DELETE",
                      body
                    );

                    if (response.ok) {
                      // On success, user loses access to the project; redirect to dashboard
                      const data = await response.json().catch(() => ({}));
                      setNotification({
                        type: "success",
                        content: data.message || "Left project successfully.",
                      });
                      closeLeaveProject();
                      window.location.assign("/dashboard");
                    } else {
                      const errorData = await response.json().catch(() => ({}));
                      setNotification({
                        type: "failure",
                        content:
                          (errorData.errors && errorData.errors[0]) ||
                          errorData.error ||
                          "Failed to leave project.",
                      });
                    }
                  } catch (err) {
                    setNotification({
                      type: "failure",
                      content: err?.message || "An unexpected error occurred.",
                    });
                  }
                }}
                disabled={isOwner && !selectedNewOwner}
              >
                Leave Project
              </Button>
            </Group>
          </Group>
        </Stack>
      </Modal>

      {/* Edit Category Modal */}
      <EditCategoryDrawer
      drawerOpened={drawerOpened}
      setDrawerOpened={setDrawerOpened}
      selectedCategory={selectedCategory}
      setSelectedCategory={setSelectedCategory}
      isNewCategory={isNewCategory}
      setIsNewCategory={setIsNewCategory}
    />
    </>
  );
};

export default MobileRoadmapView;